import { combineReducers } from "redux";
import dashboardFilter from "./dashboardFilter";


export default combineReducers({ dashboardFilter });
